import http from '@/vendor/axios'

export function createObjectiveComment (objectiveId, comment) {
  const url = `/object/okr.objective/${objectiveId}/comment`
  return http.post(url, {
    params: {
      kwargs: {
        body: comment.content,
        parent_id: comment.parentId,
        reply_to_id: comment.replyToId,
        mention_user_ids: comment.mentionedUserIds,
        attachment_ids: comment.attachmentIds
      }
    }
  })
}

export function createKeyResultComment (keyResultId, comment) {
  const url = `/object/okr.keyresult/${keyResultId}/comment`
  return http.post(url, {
    params: {
      kwargs: {
        body: comment.content,
        parent_id: comment.parentId,
        reply_to_id: comment.replyToId,
        mention_user_ids: comment.mentionedUserIds,
        attachment_ids: comment.attachmentIds
      }
    }
  })
}

export function createOkrListReview (okrListId, review) {
  const url = `/object/okr.okrlist/${okrListId}/comment`
  return http.post(url, {
    params: {
      kwargs: {
        body: review.content,
        parent_id: review.parentId,
        reply_to_id: review.replyToId,
        mention_user_ids: review.mentionedUserIds,
        attachment_ids: review.attachmentIds
      }
    }
  })
}

export function deleteComment (id) {
  const url = `/api/mail.message/${id}`
  return http.put(url, {
    params: {
      data: {
        active: false
      }
    }
  })
}
